export const MAX_WIDTH_SMALL_SCREEN = 1000;

// export const GPT_MODELS = ['GPT 3.5', 'GPT 4']
// export type GptModel = typeof GPT_MODELS[number];